export default "__VITE_ASSET__283125e5__"